import { withStyles } from 'tss-react/mui';
import { TableRow } from '@mui/material';

export const PruTableRow = withStyles(TableRow, (theme) => ({
  root: {
    "&:hover": {
      backgroundColor: theme.palette.action.hover
    }
  },
}));